import styled from "styled-components";

export default styled.div`
  padding: 10px 0;
  margin: auto;

  .search__wrapper {
    display: flex;
    .search__box--wrapper {
      display: flex;
      align-items: flex-start;
      height: 46px;
      position: relative;
      border-radius: 4px;

      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      flex: 1 1 auto;
      .search__logo {
        flex: 0 0 auto;
        max-width: 150px;
      }
      .search__form--container {
        flex: 1 1 auto;
        height: 100%;
        position: relative;
        form {
          border-radius: 4px;
          position: absolute;
          border: 1px solid rgba(128, 128, 128, 0.2);
          z-index: 2;
          top: -1px;
          right: -1px;
          left: -1px;
          .form__fields {
            border: 2px solid ${(props) => props.theme.colors.primary.aqua};
            border-radius: 6px;
            display: flex;
            flex: 1 1 auto;
            z-index: 2;
            position: relative;
            input {
              margin: 0 !important;
              width: 100%;
              // width: calc(100% - 53px);
              border-radius: 0;
              flex-basis: auto;
              flex-grow: 0;
              flex-shrink: 1;
              border: 0;
              padding: 15px;
              font-size: 14px !important;
              &:hover,
              &:active,
              &:focus {
                outline: none;
              }
            }
            .button__submit {
              height: auto;
              width: 50px;
              background-color: #2f2f2f;
              border-top-right-radius: 3px;
              border-bottom-right-radius: 3px;
              transition: border-radius 10ms cubic-bezier(0, 0, 0.2, 1) 10ms;
              svg {
                color: #fffc;
              }

              &.active {
                border-bottom-right-radius: 0;
                transition: border-radius 10ms cubic-bezier(0, 0, 0.2, 1) 10ms;
              }
            }
          }
        }
      }
    }
  }
  .backdrop {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    &.active {
      visibility: visible;
      opacity: 1;
      transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  }

  &.search__header {
    margin: unset;

    .search__wrapper {
      .search__box--wrapper {
        .search__form--container {
          form {
            border-top: unset;
            border-left: unset;
            border-right: unset;
          }
        }
      }
    }
  }

  .search__submit {
    color: ${(props) => props.theme.colors.primary.spanishGray};
    background-color: ${(props) => props.theme.colors.primary.contrast};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.9px;
    height: 100%;
    border-left: 1px solid ${(props) => props.theme.colors.primary.aqua};
  }

  .input-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .input-wrapper input {
    font-style: italic;
  }

  @media screen and (max-width: 399px) {
    .search__wrapper {
      width: 100%;
    }
    .form__fields {
      width: 60%;
    }
  }

  @media screen and (min-width: 400px) and (max-width: 510px) {
    .search__wrapper {
      width: 100%;
    }
    .form__fields {
      width: 70%;
    }
  }

  @media screen and (max-width: 640px) {
    input {
      font-size: 12px !important;
    }
  }

  @media screen and (max-width: 1220px) {
    .form__fields {
      border: 0px !important;
      width: fit-content;
      .search-engine__wrapper {
        display: none !important;
      }
      .search__submit {
        background-color: ${(props) => props.theme.colors.primary.aqua};
        color: ${(props) => props.theme.colors.primary.contrast};
      }
    }
  }
`;
